module.exports = __webpack_public_path__ + "files/97b0eff7ee726a1877f223c7c902a13e.svg";